// extracted by mini-css-extract-plugin
export default {"capabilityItemWrapper":"styles_capabilityItemWrapper__5yCxq","rightPos":"styles_rightPos__uHU5t"};